module.exports = __webpack_public_path__ + "static/oblakoder-footer-a91dad29baf53904e553d7ed01bf9399.jpg";